import { render, staticRenderFns } from "./eparisheva_home-middle1.vue?vue&type=template&id=24e50494&scoped=true"
import script from "./eparisheva_home-middle1.vue?vue&type=script&lang=js"
export * from "./eparisheva_home-middle1.vue?vue&type=script&lang=js"
import style0 from "./eparisheva_home-middle1.vue?vue&type=style&index=0&id=24e50494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e50494",
  null
  
)

export default component.exports